export enum SUGGESTION_KEY {
    category_name_keywords = 'category_name_keyword',
    display_name_keywords = 'display_name_keyword',
    seo_detail_keywords = 'seo_detail_keyword'
}


